
import { Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { AuthService } from '../../../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LOGIN_ROUTE } from '../../../shared/constants/constants';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  imports: [RouterModule, ReactiveFormsModule, FormsModule, TranslateModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  resetPasswordForm: FormGroup;
  genericErrorTranslated = '';
  successToastrMessage = '';

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.genericErrorTranslated = this.translateService.instant('errors.generic_error');
    this.successToastrMessage = this.translateService.instant('success');
  }

  ngOnInit() {
    this.resetPasswordForm = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$')
        ]
      ],
      password_confirmation: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$')
        ]
      ],
      token: [''],
      email: ['']
    });
    this.route.params.subscribe((params: any) => {
      this.resetPasswordForm.patchValue({
        token: params['token'],
        email: params['email']
      });
    });
  }

  passwordsMatch(): boolean {
    return (
      this.resetPasswordForm &&
      this.resetPasswordForm.value.password === this.resetPasswordForm.value.password_confirmation
    );
  }

  resetPassword() {
    this.authService
      .resetPassword({
        ...this.resetPasswordForm.value
      })
      .subscribe({
        next: (data: any) => {
          this.toastr.success(
            data?.message ?? this.translateService.instant('reset-password.success'),
            this.successToastrMessage
          );
          setTimeout(() => {
            this.router.navigate([LOGIN_ROUTE]);
          }, 3000);
        },
        error: (error) => {
          console.error('Error on reset pasword', error);
          this.toastr.error(this.genericErrorTranslated, error.message);
        },
        complete: () => {}
      });
  }
}
